import { FavoritesBtnType } from '../interfaces'

const FavoritesBtn = ({ handleAdd, handleRemove, saved }: FavoritesBtnType) => {
  return (
    <button
      onClick={saved ? handleRemove : handleAdd}
      className="btn-secondary btn-mobile no-print"
      type="button"
      name={saved ? 'remove plant from favourites' : 'add plant to favourites'}
    >
      <span className="btn-tertiary">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 12.509"
          width="14"
          height="12.509"
        >
          <path
            fill={saved ? '#007497' : 'none'}
            stroke="#007497"
            strokeWidth="2"
            transform="translate(-10.9 -13.4)"
            d="M 20.637 14.4 a 3.2 3.2 0 0 0 -2.745 1.586 A 3.164 3.164 0 0 0 15.148 14.4 A 3.4 3.4 0 0 0 11.9 17.876 a 3.007 3.007 0 0 0 0.579 1.936 a 64.47 64.47 0 0 0 4.613 4.657 a 1.182 1.182 0 0 0 1.63 0 a 64.654 64.654 0 0 0 4.6 -4.656 a 3.033 3.033 0 0 0 0.579 -1.936 A 3.405 3.405 0 0 0 20.637 14.4 Z"
          />
        </svg>
      </span>
      {saved ? 'REMOVE FROM FAVOURITES' : 'ADD TO FAVOURITES'}
    </button>
  )
}

export default FavoritesBtn
